function createRequest(requestType, url, contentType, token, onSuccess, onError) {
    const xhr = new XMLHttpRequest();

    xhr.open(requestType, url);

    if (contentType) {
        xhr.setRequestHeader('Content-Type', contentType);
    }

    xhr.setRequestHeader('Access-Control-Allow-Origin', '*');
    xhr.setRequestHeader('Authorization', 'Bearer ' + token);

    xhr.onload = (event) => {
        if (event.currentTarget.status === 201 || event.currentTarget.status === 200 || event.currentTarget.status === 204) {
            onSuccess(event.currentTarget.responseText);
        } else {
            onError();
        }
    };

    xhr.onerror = onError;
    xhr.ontimeout = onError;
    xhr.onabort = onError;

    return xhr;
}

function getApiSuffix(urlEnv) {
    switch (urlEnv) {
        case 'qa':
            return '-qa';
        case 'dev':
        case 'local':
            return '-dev';
        default:
            return '';
    }
}

function getApiEndpoint(urlEnv, isFedramp) {
    switch (urlEnv) {
        case 'staging':
        case 'qa':
        case 'dev':
        case 'local':
            return isFedramp ? 'https://api-stg.afg.us.autodesk.com' : 'https://developer-stg.api.autodesk.com';
        default:
            return isFedramp ? 'https://api.afg.us.autodesk.com' : 'https://developer.api.autodesk.com';
    }
}

export function fetch2dLocations(getAccessToken, containerId, documentLineageUrn, urlEnv, isFedramp) {
    return new Promise((resolve, reject) => {
        getAccessToken((token) => {
            if(!token) {
                return reject('Invalid access token.');
            }

            const endpoint = getApiEndpoint(urlEnv, isFedramp);
            const suffix = getApiSuffix(urlEnv);
            const api = `bim360/locations${suffix}/v2`;
            const treeId = 'default'; // Currently this is the only treeId that's supported.
            const url = `${endpoint}/${api}/containers/${containerId}/trees/${treeId}/nodes:search`;
            let results = [];

            // Handle fetching with pagination.
            function doFetch(url) {
                function onSuccess(response) {
                    const responseJson = JSON.parse(response);
                    results = results.concat(responseJson.results);

                    if (responseJson.pagination.next) {
                        doFetch(endpoint + responseJson.pagination.next);
                    } else {
                        resolve(results);
                    }
                }

                const xhr = createRequest('POST', url, 'application/json', token, onSuccess, reject);

                const body = {
                    documentUrns: [documentLineageUrn]
                };

                xhr.send(JSON.stringify(body));
            }

            doFetch(url);
        });
    });
}
